// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"acaf7066","19":"b1caa1b1","145":"a662254e","198":"585752e0","381":"198d571a","398":"7c9e1f39","518":"04b7dc2a","573":"2c8a3d96","703":"e64df956","758":"047e86c3","787":"4ad804cd"}[chunkId] + ".chunk.js";
};